import { createRouter, createWebHistory } from 'vue-router';
import { useAuth } from '@/plugins/auth';
import { Route, routes } from './routes';
import { App } from 'vue';
import { useSettingsStore } from "@/stores/settingsStore";

export const router = createRouter({
  history: createWebHistory(),
  routes: routes
});

router.beforeEach(async (to, _from, next) => {
  const { loggedIn } = useAuth();
  const settingsStore = useSettingsStore();

  // Check if settings are already loaded, if not, load them
  if (to.name != 'login' && to.name != 'customers-queue-monitor' ) {
    try {
      await settingsStore.loadSettings(); // Wait for settings to load
      // clear search terms
      if (!to.path.includes('customers')) {
        localStorage.removeItem('customers-search-term')
      }
      if (!to.path.includes('pets')) {
        localStorage.removeItem('pets-search-term')
      }
      if (!to.path.includes('vet-services')) {
        localStorage.removeItem('vet-services-search-term')
      }
      if (!to.path.includes('examinations')) {
        localStorage.removeItem('examinations-search-term')
      }
    } catch (error) {
      console.error('Error loading settings:', error);
      return next(false); // Stop navigation in case of error
    }
  }

  // Not logged into a guarded route?
  if (to.meta.requiresAuth && !loggedIn()) {
    next({ name: 'login' });
  } else {
    next();
  }
});

export default {
  install: (app: App) => {
    app.use(router);
    app.config.globalProperties.$Route = Route;
  }
};
